<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Asset Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of assetTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item.name">
            <input type="checkbox" [id]="'checkbox-' + item.name"
              [checked]="isIn(draftAssetTypes, item.value!)"
              (change)="draftAssetTypes = toggleGuid(draftAssetTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item.name">{{ item.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Alarm Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "ALARM_TYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let alarm of alarmTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + alarm">
            <input type="checkbox" [id]="'checkbox-' + alarm"
              [checked]="isIn(draftAlarmTypes, alarm)"
              (change)="draftAlarmTypes = toggle(draftAlarmTypes, alarm)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + alarm">{{ alarm | translate }}</label>
        </div>
      </div>
    </div>
  </div>

</app-filter-panel>
